import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

    async getAllBUttonsFromServer(context, payload = {}) {
        try {
            let resp = await axios.get(Constants.buttonsURL, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllBUttonsFromServer][Store][Error occured while getting tags List--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async addNewButton(context, payload = {}) {
        try {
            let resp = await axios.post(Constants.buttonsURL, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[addNewButton][Store][Tag add resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[addNewButton][Store][Error occured while adding tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }

    },

    async updateExistingButton(context, payload = {}) {
        try {
            let resp = await axios.put(`${Constants.buttonsURL}/${payload._id}`, payload.updatedData);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[updateExistingButton][Store][Tag update resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[updateExistingButton][Store][Error occured while updating Button--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async deleteExistingButton(context, payload = {}) {
        try {
            let resp = await axios.delete(`${Constants.buttonsURL}/${payload._id}`, payload);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                console.log(
                    `[deleteExistingButton][Store][Tag Delete resp-->${resp.status}]`
                );
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[deleteExistingButton][Store][Error occured while deleting Tag--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                } else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async fetchComponentBasedConfiguredButtons(context, payload = {}) {
        try {
          let resp = await axios.get(Constants.componentButtonsURL, {params:payload.params});
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[fetchComponentBasedConfiguredButtons][Store][Error occured while fetchComponentBasedConfiguredButtons report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async configuredButtonClickAction(context, payload = {}) {
        try {
          let resp = "";
            resp = await axios.put(Constants.buttonActionsURL+"/"+payload._id, payload.params);
        
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[configuredButtonClickAction][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[configuredButtonClickAction][Store][Error occured while performing action--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async updateConfiguredButtonsToTheComponents(context, payload = {}) {
        try {
          let resp = "";
            resp = await axios.put(Constants.componentButtonsURL, payload);
        
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[updateConfiguredButtonsToTheComponents][Store][User add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateConfiguredButtonsToTheComponents][Store][Error occured while adding user--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("logOutFromServer")
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },


      async getConfiguredButtonsInSettings(context, payload = {}) {
        try {
          let resp = await axios.get(Constants.configuredButtonsURL, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
          }else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[getConfiguredButtonsInSettings][Store][Error occured while getConfiguredButtonsInSettings report list--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },
};